import {Injectable} from '@angular/core';
import {ApiService} from 'src/app/shared/services/api.service';
import {CookieService} from 'ngx-cookie-service';
import {
  NEW_PERSONAL_URL,
  PREVIOUS_URL_FOR_REDIRECT_BACK,
  TOKEN_KEY,
} from 'src/utils/constants';
import {environment} from 'src/environments/environment';
import {getDomain} from 'src/utils/helpers';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private apiService: ApiService,
    private cookieService: CookieService,
    private router: Router
  ) {
  }

  login = (credentials: any) =>
    this.apiService.post('/login', credentials, {appkey: environment.appKey});

  logout = (clientToken: string | null = null) => {
    if (clientToken) {
      return this.apiService.post(
        '/logout',
        {},
        {Authorization: `Bearer ${clientToken}`}
      );
    } else {
      const token = this.getToken();
      this.destroyToken();

      return this.apiService.post(
        '/logout',
        {},
        {Authorization: `Bearer ${token}`}
      );
    }
  };

  register = (data: any) =>
    this.apiService.post('/register', data, {appkey: environment.appKey});

  isLoggedIn = (): boolean => !!this.getToken();

  getToken = (): string => this.cookieService.get(TOKEN_KEY);

  saveToken = (token: string) => {
    const currentDate = new Date();
    const expirationDate = new Date();
    expirationDate.setDate(currentDate.getDate() + 30);

    this.cookieService.set(TOKEN_KEY, token, {
      domain: `.${getDomain()}`,
      path: '/',
      sameSite: 'Lax',
      expires: expirationDate,
    });
  };

  updateExpiresInToken = () => {
    const token = this.getToken();

    this.saveToken(token);
  };

  destroyToken() {
    this.cookieService.delete(
      TOKEN_KEY,
      '/',
      `.${getDomain()}`,
      undefined,
      'Lax'
    );
  }

  redirectToOtherApp(route: string) {
    const previousUrl = window.sessionStorage.getItem(
      PREVIOUS_URL_FOR_REDIRECT_BACK
    );

    if (previousUrl) {
      window.sessionStorage.removeItem(PREVIOUS_URL_FOR_REDIRECT_BACK);
      window.location.href = previousUrl;
    } else {
      this.router.navigate([route]);
    }
  }

  generateQueryStringForMy = (url: string) =>
    new URLSearchParams({previousUrl: url}).toString();

  redirectToNewPersonal(pageRoute?: string) {
    const previousUrl = window.sessionStorage.getItem(
      PREVIOUS_URL_FOR_REDIRECT_BACK
    );

    if (previousUrl) {
      window.sessionStorage.removeItem(PREVIOUS_URL_FOR_REDIRECT_BACK);
      window.location.href = `${NEW_PERSONAL_URL}?${this.generateQueryStringForMy(
        previousUrl
      )}`;
    } else {
      if (pageRoute) {
        window.location.href = `${NEW_PERSONAL_URL}/${pageRoute}`;
      } else {
        window.location.href = `${NEW_PERSONAL_URL}/login`;
      }
    }
  }

  recoverPassword = (data: any) =>
    this.apiService.post('/password/email', data);

  updatePassword = (data: any) => this.apiService.post('/password/reset', data);

  updatePasswordAuthorised = (data: any) =>
    this.apiService.post('/password/change', data);

  checkPassword = (password: string) =>
    this.apiService.post('/password/check', {current_password: password});

  getUserRoles = () => this.apiService.post('/my/roles');
}
